import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import find from 'lodash/find';

import { Spinner } from 'formlabs-web-components/Navigation';

import { formatPrice } from '../../utils';

import CheckoutButton from './CheckoutButton';
import ProductImage from './ProductImage';

import {
  removeItem as removeItemAction,
  updateItem as updateItemAction
} from '../../ducks/cart';

import Amount from './Amount';
import Price from './Price';

import './Cart.module.css';

class CartItem extends Component {
  handleRemove = () => {
    const { item, removeItem } = this.props;
    removeItem(item.item_id);
  };

  handleAmountUpdate = qty => {
    const { item, updateItem } = this.props;
    updateItem(item.item_id, 'qty', qty);
  };

  render() {
    const { currencyCode, item, price } = this.props;

    return (
      <li styleName="item">
        <div styleName="product">
          <ProductImage
            sku={item.sku}
            alt={item.name}
            styleName="product-image"
            placeholder={<div styleName="product-image" />}
          />
          <span>{item.name}</span>
          <button styleName="remove" onClick={this.handleRemove}>
            ×
          </button>
        </div>
        <div styleName="meta">
          <div styleName="price">
            {price}
            <span>{currencyCode}</span>
          </div>
          <Amount
            defaultValue={item.qty}
            onAmountChange={this.handleAmountUpdate}
          />
        </div>
      </li>
    );
  }
}

class Cart extends Component {
  priceFormatter = price =>
    formatPrice(price, this.props.language, this.props.currencyCode);

  render() {
    const {
      totals,
      items,
      loading,
      removeItem,
      updateItem,
      t,
      currencyCode
    } = this.props;
    const itemCount = items.length;

    return (
      <div>
        {itemCount > 0 && (
          <div styleName="cart">
            <p styleName="title">{t('Cart')}</p>
            <p styleName="item-count">
              {itemCount} {itemCount > 1 ? 'items' : 'item'}
            </p>

            <ul styleName="items">
              {items.map(item => {
                const totalItem = find(
                  totals.items,
                  totalItem => totalItem.item_id === item.item_id
                );

                const price = this.priceFormatter(
                  totalItem && totalItem.row_total ? totalItem.row_total : 0
                );

                return (
                  <CartItem
                    key={item.item_id}
                    currencyCode={currencyCode}
                    price={price}
                    item={item}
                    removeItem={removeItem}
                    updateItem={updateItem}
                  />
                );
              })}
            </ul>

            <div styleName="total">
              <span styleName="sum-label">{t('Subtotal')}</span>
              <span styleName="price">
                {loading ? (
                  <span styleName="spinner">
                    <Spinner size={4} />
                  </span>
                ) : (
                  <Price price={totals.subtotal}>
                    <span>{currencyCode}</span>
                  </Price>
                )}
              </span>
            </div>

            <div styleName="button">
              <CheckoutButton />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  connect(
    state => {
      return {
        totals: state.cart.totals,
        loading: state.cart.cartUpdating,
        items: state.cart.items,
        language: state.i18n.language,
        currencyCode: state.i18n.currency
      };
    },
    dispatch => {
      return {
        removeItem: itemId => {
          dispatch(removeItemAction(itemId));
        },
        updateItem: (itemId, key, value) => {
          dispatch(updateItemAction(itemId, key, value));
        }
      };
    }
  ),
  withTranslation()
)(Cart);
